/**
 * @description
 */

export interface IUndoRedoSnapshot<T> {
    current: T[];
    future: T[];
}

export default class UndoRedo<T = {}> {
    /**
     * 操作历史栈
     */
    private current: T[] = [];

    /**
     * 被撤销的历史栈
     */
    private future: T[] = [];

    constructor() {
        /*  */
    }

    /**
     * 记录历史
     */
    public do(action: T) {
        this.current.push(action);
        this.future = [];
    }

    /**
     * 是否可撤销
     */
    public isUndoable() {
        const last = this.current.slice(-1).pop();
        return last;
    }

    /**
     * 执行撤销操作
     */
    public undo() {
        if (!this.isUndoable()) {
            return;
        }
        const action = this.current.pop();
        if (action) {
            this.future.push(action);
        }
        return action;
    }

    /**
     * 是否可重做
     */
    public isRedoable() {
        const last = this.future.slice(-1).pop();
        return last;
    }

    /**
     * 执行重做操作
     */
    public redo() {
        if (!this.isRedoable()) {
            return;
        }
        const action = this.future.pop();
        if (action) {
            this.current.push(action);
        }
        return action;
    }

    /**
     * 响应删除
     */
    public delete(predicate: (value: T, index: number, obj: T[]) => boolean) {
        this.current.splice(this.current.findIndex(predicate));
        this.future = [];
    }

    /**
     * 获取历史更新时添加快照，方便在删除时恢复
     */
    public getSnapshot() {
        return {
            current: this.current.slice(),
            future: this.future.slice(),
        };
    }

    /**
     * 从快照恢复历史
     */
    public recoverFromSnapshot(snapshot?: IUndoRedoSnapshot<T>) {
        if (snapshot) {
            this.current = snapshot.current;
            this.future = snapshot.future;
        } else {
            this.current = this.future = [];
        }
    }
}
